<p-drawer header="Nuevo grupo de precios" [(visible)]="visible" [dismissible]="false" [closable]="false" position="right" [style]="{ 'max-width': '600px', width: '90%' }" [closeOnEscape]="false">
  <form [formGroup]="form" class="card border-0">
    <div class="card-body p-0">
      <div class="py-3 d-flex flex-column gap-4">
        <div class="d-flex flex-column gap-2">
          <p-divider align="left" class="m-0">
            <b>Nombre del grupo</b>
          </p-divider>

          <input formControlName="NAME" pInputText class="w-100 h-50px" />
        </div>

        <div class="d-flex flex-column gap-2">
          <p-divider align="left" class="m-0">
            <b>Usuarios</b>
          </p-divider>

          <p-multiSelect formControlName="USERS" [options]="listUsers" placeholder="Selecciona uno o más usuarios" scrollHeight="250px" display="chip" styleClass="w-100 h-50px" appendTo="body" />
        </div>
      </div>

      <p-tabView formGroupName="PRICES" class="w-100" scrollable="true">
        <p-tabPanel header="REGISTRO CIVIL" formGroupName="REGISTRO_CIVIL">
          <div class="py-3 d-flex flex-column gap-4">
            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Digitalización</b>
              </p-divider>

              <p-inputnumber formControlName="DIGITALIZACION" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Corrección acta</b>
              </p-divider>

              <p-inputnumber formControlName="CORRECCION_ACTA" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Marcos, folios y reversos</b>
              </p-divider>

              <p-inputnumber formControlName="MARCO_FOLIO_REVERSO" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>
          </div>

          <div class="py-3 d-flex flex-column gap-4">
            <div formGroupName="BUSCAR_ACTO">
              <p-divider align="left" class="m-0">
                <b>Buscar acto</b>
              </p-divider>
              <ng-container *ngFor="let estado of Object.keys(form.get('PRICES.REGISTRO_CIVIL.BUSCAR_ACTO')?.value || {})">
                <div class="mb-2">
                  <p-fieldset legend="{{ formatEstadoName(estado) }}">
                    <div [formGroupName]="estado" class="d-flex flex-column gap-2">
                      <p-inputgroup>
                        <p-inputgroup-addon [style]="{ minWidth: 'fit-content', width: '150px', 'justify-content': 'start' }"><span class="px-2">Nacimiento</span></p-inputgroup-addon>
                        <p-inputnumber formControlName="NACIMIENTO" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" min="0" />
                      </p-inputgroup>
                      <p-inputgroup>
                        <p-inputgroup-addon [style]="{ minWidth: 'fit-content', width: '150px', 'justify-content': 'start' }"><span class="px-2">Matrimonio</span></p-inputgroup-addon>
                        <p-inputnumber formControlName="MATRIMONIO" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                      </p-inputgroup>
                      <p-inputgroup>
                        <p-inputgroup-addon [style]="{ minWidth: 'fit-content', width: '150px', 'justify-content': 'start' }"><span class="px-2">Defunción</span></p-inputgroup-addon>
                        <p-inputnumber formControlName="DEFUNCION" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                      </p-inputgroup>
                      <p-inputgroup>
                        <p-inputgroup-addon [style]="{ minWidth: 'fit-content', width: '150px', 'justify-content': 'start' }"><span class="px-2">Divorcio</span></p-inputgroup-addon>
                        <p-inputnumber formControlName="DIVORCIO" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
                      </p-inputgroup>
                    </div>
                  </p-fieldset>
                </div>
              </ng-container>
            </div>
          </div>
        </p-tabPanel>

        <p-tabPanel header="SAT" formGroupName="SAT">
          <div class="py-3 d-flex flex-column gap-4">
            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Cambio de emisión</b>
              </p-divider>
              <p-inputnumber formControlName="CAMBIO_EMISION" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Cédula de identificación fiscal</b>
              </p-divider>
              <p-inputnumber formControlName="CEDULA_IDENTIFICACION_FISCAL" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Cita persona física</b>
              </p-divider>
              <p-inputnumber formControlName="CITA_PERSONA_FISICA" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Constancia de situación fiscal</b>
              </p-divider>
              <p-inputnumber formControlName="CONSTANCIA_SITUACION_FISCAL" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Opinión del cumplimiento</b>
              </p-divider>
              <p-inputnumber formControlName="OPINION_CUMPLIMIENTO" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Recuperación de CFDI</b>
              </p-divider>
              <p-inputnumber formControlName="RECUPERACION_CFDI" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Recuperación de declaración</b>
              </p-divider>
              <p-inputnumber formControlName="RECUPERACION_DECLARACION" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Cita persona moral</b>
              </p-divider>
              <p-inputnumber formControlName="CITA_PERSONA_MORAL" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Alta RFC primera vez con contraseña</b>
              </p-divider>
              <p-inputnumber formControlName="ALTA_RFC_PRIMERA_VEZ_CON_CONTRASENA" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Alta RFC primera vez sin contraseña</b>
              </p-divider>
              <p-inputnumber formControlName="ALTA_RFC_PRIMERA_VEZ_SIN_CONTRASENA" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Contraseña CIEC con INE</b>
              </p-divider>
              <p-inputnumber formControlName="CONTRASENA_CIEC_INE" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>
          </div>
        </p-tabPanel>

        <p-tabPanel header="IMSS" formGroupName="IMSS">
          <div class="py-3 d-flex flex-column gap-4">
            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Consultar NSS</b>
              </p-divider>
              <p-inputnumber formControlName="CONSULTAR_NSS" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Información NSS</b>
              </p-divider>
              <p-inputnumber formControlName="INFORMACION_NSS" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Asignar correo NSS</b>
              </p-divider>
              <p-inputnumber formControlName="ASIGNAR_CORREO_NSS" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Semanas cotizadas</b>
              </p-divider>
              <p-inputnumber formControlName="SEMANAS_COTIZADAS" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Vigencia derecho</b>
              </p-divider>
              <p-inputnumber formControlName="VIGENCIA_DERECHO" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>No derechohabiente</b>
              </p-divider>
              <p-inputnumber formControlName="NO_DERECHOHABIENTE" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>
          </div>
        </p-tabPanel>

        <p-tabPanel header="RENAPO" formGroupName="RENAPO">
          <div class="py-3 d-flex flex-column gap-4">
            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>CURP</b>
              </p-divider>
              <p-inputnumber formControlName="CURP" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Corrección de CURP</b>
              </p-divider>
              <p-inputnumber formControlName="CORRECCION_CURP" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Unificación de CURP</b>
              </p-divider>
              <p-inputnumber formControlName="UNIFICACION_CURP" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Certificación de CURP</b>
              </p-divider>
              <p-inputnumber formControlName="CERTIFICACION_CURP" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>
          </div>
        </p-tabPanel>

        <p-tabPanel header="ISSSTE" formGroupName="ISSSTE">
          <div class="py-3 d-flex flex-column gap-4">
            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Talón de pagos</b>
              </p-divider>
              <p-inputnumber formControlName="TALON_PAGOS" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>

            <div class="d-flex flex-column gap-2">
              <p-divider align="left" class="m-0">
                <b>Constancia de acreditación de no afiliación</b>
              </p-divider>
              <p-inputnumber formControlName="CONSTANCIA_ACREDITACION_NO_AFILIACION" mode="currency" currency="MXN" locale="es-MX" styleClass="w-100 h-50px" class="w-100 h-50px" />
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
  </form>

  <ng-template #footer>
    <div class="d-flex align-items-center justify-content-between gap-2">
      <p-button (click)="closeDrawer()" label="Cancelar" severity="secondary" size="small" class="w-50" styleClass="w-100 py-3" [disabled]="isSaving" />
      <p-button (click)="createPricingGroup()" label="Guardar" icon="pi pi-save" severity="success" size="small" class="w-50" styleClass="w-100 py-3" [loading]="isSaving" [disabled]="form.invalid" />
    </div>
  </ng-template>
</p-drawer>
